import './Array.find'
import './Array.findIndex'
import './Array.includes'
import './Array.indexOf'
import './Number.isInteger'
import './Number.isNan'
import './Object.entries'
import './String.includes'
import './String.repeat'
import './String.startsWith'



// WEBPACK FOOTER //
// ./src/common/general/js/polyfills/index.js